/**
 * Google Analytics 4 integration
 * Respeta el consentimiento de cookies del usuario.
 * Solo se carga si el usuario ha aceptado cookies analíticas.
 */

const GA_MEASUREMENT_ID =
  import.meta.env.VITE_GA_MEASUREMENT_ID || "G-8LVXQB508F";

const COOKIE_SETTINGS_KEY = "rm_cookie_settings";

let ga4Loaded = false;

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

function loadGA4() {
  if (ga4Loaded) return;
  if (document.querySelector('script[src*="googletagmanager"]')) {
    ga4Loaded = true;
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_MEASUREMENT_ID, { anonymize_ip: true });

  ga4Loaded = true;
}

/** Inicializa GA4: carga si ya hay consentimiento y escucha cambios futuros */
export function initGA4() {
  // Verificar consentimiento existente
  try {
    const stored = localStorage.getItem(COOKIE_SETTINGS_KEY);
    if (stored) {
      const settings = JSON.parse(stored);
      if (settings.analytics) {
        loadGA4();
      }
    }
  } catch {
    // ignore
  }

  // Escuchar cambios de consentimiento
  const handler = (e: Event) => {
    const detail = (e as CustomEvent).detail;
    if (detail?.analytics) {
      loadGA4();
    }
  };
  window.addEventListener("cookieConsentChanged", handler);

  return () => {
    window.removeEventListener("cookieConsentChanged", handler);
  };
}

/** Enviar evento personalizado a GA4 */
export function trackEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>,
) {
  if (window.gtag) {
    window.gtag("event", eventName, params);
  }
}
